const state = {
    pro_id:'',
    proInfo:{},
    category:'',
    pro_class:'' || localStorage.getItem('initiate_pro_class'),
    disabled:false,
    if_show:0,
    initDone:false,
}
const getters = {
    pro_id: state => state.pro_id,
    proInfo: state => state.proInfo,
    category: state => state.category,
    pro_class: state => state.pro_class,
    disabled: state => state.disabled,
    if_show: state => state.if_show,
    initDone: state => state.initDone,
}
const mutations = {
    currentProId(state, update) {
        state.pro_id = update
    },
    currentProInfo(state, update) {
        state.proInfo = update
    },
    currentCategory(state, update) {
        state.category = update
    },
    currentProClass(state, update) {
        state.pro_class = update
    },
    currentDisabled(state, update) {
        state.disabled = update
    },
    currentIfShow(state, update) {
        state.if_show = update
    },
    currentInitDone(state, update) {
        state.initDone = update
    },
  };
const actions = {
    setProId({commit}, pro_id) {
        commit('currentProId',pro_id)
    },
    setProInfo({commit}, proInfo) {
        commit('currentProInfo',proInfo)
    },
    setCategory({commit}, category) {
        commit('currentCategory',category)
    },
    setProClass({commit}, pro_class) {
        commit('currentProClass',pro_class)
    },
    setDisabled({commit}, disabled) {
        commit('currentDisabled',disabled)
    },
    setIfShow({commit}, if_show) {
        commit('currentIfShow',if_show)
    },
    setInitDone({commit}, initDone) {
        commit('currentInitDone',initDone)
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}
